// Email service using AWS Lambda function via API Gateway
const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://bjijyxiaia.execute-api.eu-west-2.amazonaws.com/Prod/send-email'
  : 'https://bjijyxiaia.execute-api.eu-west-2.amazonaws.com/Prod/send-email';

const handleResponse = async (response) => {
  if (!response.ok) {
    let errorMessage = 'Failed to send email';
    try {
      const error = await response.json();
      errorMessage = error.error || error.details || errorMessage;
    } catch (parseError) {
      // If response isn't JSON, get the text
      const errorText = await response.text();
      console.error('Non-JSON error response:', errorText);
      errorMessage = `Server error (${response.status}): ${errorText.substring(0, 100)}`;
    }
    throw new Error(errorMessage);
  }
  return await response.json();
};

export const sendGeneralEnquiry = async (formData) => {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      type: 'general',
      formData
    }),
  });

  return await handleResponse(response);
};

export const sendWelfareEnquiry = async (formData) => {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      type: 'welfare',
      formData
    }),
  });

  return await handleResponse(response);
};

export const sendMastersInterest = async (formData) => {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      type: 'masters-interest',
      formData
    }),
  });

  return await handleResponse(response);
};